import { actions as collection } from '@/plugins/Collection'

export default collection.toOptions({
  lessThanYear: 'Less than a year',
  between1And3: '1 - 3 years',
  between3And5: '3 - 5 years',
  over5: 'Over 5 years'
})
